module.exports = __webpack_public_path__ + "static/img/bg2.dff12ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/bg2.jpg
// module id = 9B8P
// module chunks = 0